import { render } from "./Hospital.vue?vue&type=template&id=1889be65&scoped=true"
import script from "./Hospital.vue?vue&type=script&lang=js"
export * from "./Hospital.vue?vue&type=script&lang=js"

import "./Hospital.vue?vue&type=style&index=0&id=1889be65&lang=scss&scoped=scoped"

import exportComponent from "D:\\work\\粤智康医药网\\guanwang\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1889be65"]])

export default __exports__